module.exports = __webpack_public_path__ + "img/icon_service_satisfaction_questionnaire_hover.e1512969.svg";